import script from "./CommonSvgs.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonSvgs.vue?vue&type=script&setup=true&lang=js"

import "./CommonSvgs.vue?vue&type=style&index=0&id=61ab03c5&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ab03c5"]])

export default __exports__